export const getCurrentTld = (host) => {
  const [, tld] = /deliveroo(?:\.[a-z]{2,3})?\.([a-z]{2})/.exec(host) || [];
  return tld;
};

export const urlWithLocale = (currentCountry, url, language) => {
  if (currentCountry.languages.length > 1) {
    return `/${language.toLowerCase()}${url}`;
  }
  return url;
};

export const replaceLocaleForUrl = (locale, url) =>
  // Only works on paths with an existing locale string, not for countries that
  // only support one locale and omit it from the URL
  url.replace(/^\/[^/]*\//, `/${locale.toLowerCase()}/`);

export const languageForLocale = (language, isoCode) => `${language.split('-')[0]}-${isoCode}`;
